const items = {
  "buttons.submit": "提交",
  "buttons.create": "新建",
  "buttons.edit": "编辑",
  "buttons.translate": "翻译",
  "buttons.read": "阅读",
  "buttons.wbw": "逐词解析",
  "buttons.delete": "删除",
  "buttons.remove": "移除",
  "buttons.delete.all": "批量删除",
  "buttons.selected": "已选择",
  "buttons.select": "选择",
  "buttons.unselect": "全不选",
  "buttons.option": "操作",
  "buttons.save": "保存",
  "buttons.save.publish": "保存并公开到社区词典",
  "buttons.save.my.dict": "保存并添加到个人单词本",
  "buttons.cancel": "取消",
  "buttons.setting": "设置",
  "buttons.sign-in": "登录",
  "buttons.sign-out": "退出登录",
  "buttons.welcome": "欢迎遨游法的海洋",
  "buttons.click.upload": "点击上传",
  "buttons.group.exit": "退群",
  "buttons.group.add.member": "加人",
  "buttons.lesson.add.lesson": "加入",
  "buttons.ok": "确定",
  "buttons.close": "关闭",
  "buttons.copy": "复制",
  "buttons.paste": "粘贴",
  "buttons.copy.to": "复制到",
  "buttons.copy.text": "复制文本",
  "buttons.copy.pali.text": "复制巴利语文本",
  "buttons.basic.information": "基本信息",
  "buttons.share": "分享",
  "buttons.yes": "是",
  "buttons.no": "否",
  "buttons.open.in.library": "在藏经阁中打开",
  "buttons.preview": "预览",
  "buttons.view": "查看",
  "buttons.empty": "清空",
  "buttons.basic": "基本",
  "buttons.bookmark": "书签",
  "buttons.note": "注解",
  "buttons.advance": "高级",
  "buttons.attachments": "附件",
  "buttons.sim": "相似句",
  "buttons.add": "添加",
  "buttons.spell": "拼写",
  "buttons.more": "更多",
  "buttons.import": "导入",
  "buttons.export": "导出",
  "buttons.add.tag": "添加标签",
  "buttons.remove.selected": "清除选择",
  "buttons.multiple.select": "多选",
  "buttons.download": "下载",
  "buttons.download.link": "下载链接",
  "buttons.lookup": "查字典",
  "buttons.invite": "邀请",
  "buttons.relate.to": "关联到",
  "buttons.copy.link": "复制链接",
  "buttons.copy.id": "复制编号",
  "buttons.reply": "回复",
  "buttons.open": "打开",
  "buttons.compact": "紧凑",
  "buttons.magic-dict": "神奇字典",
  "buttons.theme.ant": "默认",
  "buttons.theme.dark": "夜间",
  "buttons.channel.all": "全部",
  "buttons.channel.my": "我的",
  "buttons.channel.collaborator": "协作",
  "buttons.channel.public": "公开",
  "buttons.refresh": "刷新",
  "buttons.timeline": "时间线",
  "buttons.discussion": "讨论",
  "buttons.suggestion": "修改建议",
  "buttons.accept": "接受",
  "buttons.refuse": "拒绝",
  "buttons.use.as.guest": "以访客身份继续使用",
  "buttons.got.it": "知道了",
  "buttons.statistic": "统计",
  "buttons.relate": "关联",
  "buttons.convert": "转换",
  "buttons.copy.tpl": "复制模版",
  "buttons.open.in.new.tab": "在新标签页中打开{item}",
  "buttons.add_to_anthology": "添加到文集",
  "buttons.open.in.studio": "在Studio中打开",
  "buttons.admin": "后台管理",
  "buttons.open.in.tab": "在新标签页中打开",
  "buttons.reset.wbw": "重置逐词解析",
  "buttons.reset.password": "重置密码",
  "buttons.forgot.password": "忘记密码",
  "buttons.select.channel": "选择版本风格",
  "buttons.set.display.mode": "显示模式",
  "buttons.manage": "管理",
  "buttons.delete.wbw.sentence": "删除整句逐词解析",
  "buttons.ai.translate": "AI 翻译",
  "buttons.task.status.change.to.pending": "未发布",
  "buttons.task.status.change.to.published": "发布",
  "buttons.task.status.change.to.running": "领取",
  "buttons.task.status.change.to.done": "完成任务",
  "buttons.task.status.change.to.restarted": "重做",
  "buttons.task.status.change.to.requested_restart": "请求重做",
  "buttons.task.status.change.to.quit": "放弃任务",
  "buttons.access-token.get": "获取访问口令",
  "buttons.task.add.pre-task": "添加前置任务",
  "buttons.task.add.next-task": "添加后置任务",
  "buttons.remove.milestone": "移除里程碑",
  "buttons.set.milestone": "设置为里程碑",
  "buttons.next": "下一步",
  "buttons.previous": "上一步",
  "buttons.clone": "克隆",
  "buttons.general": "常规",
  "buttons.ai-models": "AI模型",
  "buttons.new": "新建",
};

export default items;
